export default "__VITE_ASSET__B3l7qHbS__"